export default __webpack_public_path__ + "static/media/DemianBellumio.d157bcc8.png";